import * as React from 'react';
import Modal from '../../misc/components/modal';
import { AuditModalBody } from './AuditModalBody';
import Alert, { AlertCategoryEnum } from '../../misc/components/Alert';

export interface AuditForm {
    Annotation: string;
    Password: string;
}

export interface AuditModalProps {
    header: string;
    isSubmitting: boolean;
    onSubmit: (values: AuditForm) => void;
    onClose: () => void;
    error?: string | JSX.Element;
    warning?: string | JSX.Element;
    annotationMaxLength?: number;
}

export const AuditModal = ({ header, isSubmitting, onSubmit, onClose, error, warning, annotationMaxLength }: AuditModalProps) => {
    return (
        <Modal show={true} closeModalHandler={onClose} header={header}>
            <Alert show={!!warning} category={AlertCategoryEnum.Warning}>
                {warning}
            </Alert>
            <Alert show={!!error} category={AlertCategoryEnum.Danger}>
                {error}
            </Alert>
            <AuditModalBody annotationMaxLength={annotationMaxLength} isSubmitting={isSubmitting} onSubmit={(form) => onSubmit(form)} onClose={onClose} />
        </Modal>
    );
}

